import VerifyEmail from './entities/verify-email';
import ResetPassword from './entities/reset-password';
import ForgotPassword from './entities/forgot-password';
import ActivateAccount from './entities/activate-account';

export default {
  modules: {
    VerifyEmail,
    ResetPassword,
    ForgotPassword,
    ActivateAccount,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication/index.js